const pickDefault = (m) => m.default || m;
const loadParallel = (tasks) => Promise.all(tasks.map((task) => task()));
const loadOrdered = (tasks) => tasks.reduce((p, task) => p.then(task), Promise.resolve());

const bundleParallel = (entries, pick = pickDefault) =>
	loadParallel(entries).then(([m]) => pick(m));

const bundleOrdered = (entries, pick = pickDefault) => {
	let main;
	return loadOrdered(entries.map((entry, i) => () => entry().then((m) => {
		if (i === 0) {
			main = m;
		}
		return m;
	}))).then(() => pick(main));
};

export const loadLib = {
	toastr: () => bundleParallel([
		() => import(/* webpackChunkName: "frontend/toastrBundle" */ 'toastr'),
		() => import(/* webpackChunkName: "frontend/toastrBundle" */ 'toastr/build/toastr.css'),
	]),
	ionRangeSlider: () => bundleOrdered([
		() => import(/* webpackChunkName: "frontend/ionRangeSliderBundle" */ 'ion-rangeslider'),
		() => import(/* webpackChunkName: "frontend/ionRangeSliderBundle" */ 'ion-rangeslider/css/ion.rangeSlider.min.css'),
		() => import(/* webpackChunkName: "frontend/ionRangeSliderBundle" */ '../../../../sass/vg/02-plugins/_ion-range.scss'),
	]),
	yandexMap: () => import(/* webpackChunkName: "frontend/yandexMap" */ "../../../../../modules/vegas/js/maps/YandexMap").then((m) => pickDefault(m)),
	bootstrapCollapse: () => import(/* webpackChunkName: "frontend/bootstrap" */ "../../../../../modules/index.esm").then(m => m.Collapse || m.default.Collapse),
	vegasModules: () => import(/* webpackChunkName: "frontend/vegasModules" */ "../../../../../modules/index.esm").then((m) => pickDefault(m)),
	bootstrap: () => import(/* webpackChunkName: "frontend/bootstrap" */ "../../../../../modules/index.esm").then((m) => pickDefault(m)),
	vgMap: () => import(/* webpackChunkName: "frontend/vgMap" */ "../../../../../modules/vegas/js/maps/map").then((m) => pickDefault(m)),
	catalogFilters: () => import(/* webpackChunkName: "frontend/catalogFilters" */ "../modules/catalog/filters/filters.module"),
	catalogOrder: () => import(/* webpackChunkName: "frontend/catalogOrder" */ "../modules/catalog/order/order.module"),
	fancybox: () => bundleParallel([
		() => import(/* webpackChunkName: "frontend/fancyboxBundle" */ "@fancyapps/ui/dist/fancybox/fancybox.esm"),
		() => import(/* webpackChunkName: "frontend/fancyboxBundle" */ "@fancyapps/ui/dist/fancybox/fancybox.css"),
	], (m) => m.Fancybox || m.default?.Fancybox || m.default),
	vgrollup: () => bundleParallel([
		() => import(/* webpackChunkName: "frontend/rollupBundle" */ "vgrollup/src/VGRollup/js/VGRollup"),
		() => import(/* webpackChunkName: "frontend/rollupBundle" */ "vgrollup/src/VGRollup/scss/vgrollup.scss"),
		() => import(/* webpackChunkName: "frontend/rollupBundle" */ "../../../../sass/vg/02-plugins/_vgrollup.scss"),
	], (m) => m.default),
	inputmask: () => import(/* webpackChunkName: "frontend/inputmask" */ "inputmask/dist/inputmask.es6").then((m) => pickDefault(m)),
	tooltip: () => import(/* webpackChunkName: "frontend/tooltip" */ "../../../../../modules/boot/js/tooltip").then((m) => pickDefault(m)),
};
